module.exports = __webpack_public_path__ + "static/media/Book-Pile.be1b380c.png";